<div class="toolbar is-flex is-column bg-grey-0 radius-12 gap-8">
  @if (loggedIn()) {
    @if (outdoorModules().length > 0) {
      <app-toolbar-item
        [selected]="selectedPanel() === Panel.DASHBOARD"
        (click)="clickToolbarItem(Panel.DASHBOARD, $event)"
        ga-event="panel-dashboard"
        [label]="'station.__SETTINGS_FAVORITES' | AsyncLang | async"
      >
        <app-icon class="text-24" name="rate" />
      </app-toolbar-item>

      <a href="https://home.netatmo.com?utm_source=weathermap&utm_medium=referral&utm_content=weathermap_toolbar">
        <app-toolbar-item [label]="'app.__MAP_APP_TOOLTIP' | AsyncLang | async">
          <app-icon class="text-24" name="netatmo" />
        </app-toolbar-item>
      </a>
    }
  }

  <app-toolbar-item
    [label]="'app.__MAP_HOVER_FILTERS_BUTTON' | AsyncLang | async"
    [selected]="selectedPanel() === Panel.FILTERS"
    (click)="clickToolbarItem(Panel.FILTERS, $event)"
  >
    <app-icon class="text-24" name="filter" />
  </app-toolbar-item>

  <a href="https://shop.netatmo.com?utm_source=weathermap&utm_medium=referral&utm_content=weathermap_toolbar">
    <app-toolbar-item [label]="'common.__COM_SETTINGS_SHOP' | AsyncLang | async">
      <app-icon class="text-24" name="shop" />
    </app-toolbar-item>
  </a>

  <app-toolbar-item (click)="openAxeptioCookies()" [label]="'legals.__COMMON_COOKIES' | AsyncLang | async">
    <app-icon class="text-24" name="cookie" />
  </app-toolbar-item>

  <app-toolbar-item
    [selected]="selectedPanel() === Panel.SETTINGS"
    (click)="clickToolbarItem(Panel.SETTINGS, $event)"
    [label]="'settings.__MY_UNITS' | AsyncLang | async"
  >
    <app-icon class="text-24" name="settings" />
  </app-toolbar-item>

  <app-login />

  @if (selectedPanel() === Panel.DASHBOARD) {
    <app-toolbar-panel @enterLeave>
      <app-dashboard (close)="closePanel()" />
    </app-toolbar-panel>
  } @else if (selectedPanel() === Panel.SETTINGS) {
    <app-toolbar-panel @enterLeave>
      <app-settings (close)="closePanel()" />
    </app-toolbar-panel>
  } @else if (selectedPanel() === Panel.FILTERS) {
    <app-toolbar-panel @enterLeave>
      <app-filters (close)="closePanel()" />
    </app-toolbar-panel>
  }
</div>

<div class="toolbar is-flex is-column bg-grey-0 radius-12 gap-8">
  <app-geolocate />

  <app-zoom />
</div>
